import locations from "../../data/projects/enums/locations";
import BaseFilter from "./BaseFilter";

interface LocationFilterProps {
  pickedOptions: string[];
  setPickedOptions: (newState: any) => void;
  show: boolean;
  setShow: (key: string) => void;
  displayColumn?: boolean;
  title?: string;
  filterKey?: string;
  isAdd?:boolean
}

export default function LocationFilter({
  pickedOptions,
  setPickedOptions,
  show,
  setShow,
  displayColumn = false,
  title = "Location",
  filterKey = "locations",
  maxDisplayOptions,
  isAdd,
}: any) {
  return (
    <BaseFilter
      pickedOptions={pickedOptions}
      setPickedOptions={setPickedOptions}
      show={show}
      setShow={setShow}
      displayColumn={displayColumn}
      title={title}
      filterKey={filterKey}
      originalOptions={locations}
      filterType="locations"
      showProposeButton={true}
      maxDisplayOptions={maxDisplayOptions}
      isAdd={isAdd}
    />
  );
}
